import BaseModule from '../../../../javascripts/helpers/baseModule';

const mobileNavigation = document.querySelector("[data-js-module='o-mobile-navigation']");
const open = document.querySelector("[data-js-module='o-mobile-navigation__open']");
const activeClass = 'mobile-navigation--active';

class MobileNavigation extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    open.addEventListener('click', event => {
      event.preventDefault();
      document.documentElement.classList.toggle(activeClass);
    });
  }
}

if (mobileNavigation) {
  new MobileNavigation(mobileNavigation); // eslint-disable-line no-new
}
